import PrizeImgInput from './prize-img-input.container';

export default PrizeImgInput;
